import axios from "../axiosConfig";
import {adminConstants} from "../../constants";
import {trackPromise} from "react-promise-tracker";

export const actionGetAttendanceVerificationOptions = () => async dispatch => {
    const response = await trackPromise(axios.get('customField/list'));
    dispatch({type: adminConstants.ACTION_GET_CUSTOM_FIELDS, payload: response.data.data});
    return response
};
